import {
  getBatchWeighStationsStatus,
  getBatchTruckStopsStatus,
  getBatchFuelPricesStatus
} from '@/api/poi'


const state = {
  namespaced: true,
  state: {
    poiDeatilLoading: false
  },
  mutations: {
    SET_POI_DETAIL_LOADING(state, status) {
      state.poiDeatilLoading = status
    }
  },
  actions: {
    getPoiInCircleStatus(context, { circlePoints, filterLabels }) {
      const { topLabel = 'All Places' } = filterLabels
      const idsArr = circlePoints.filter(item => item.ident).map(point => point.ident)
      let api = null
      if (topLabel === 'Weigh Stations Status') {
        api = getBatchWeighStationsStatus
      } else if (topLabel === 'Parking Availability') {
        api = getBatchTruckStopsStatus
      } else if (topLabel === 'Diesel Prices') {
        api = getBatchFuelPricesStatus
      }
      if (!api) {
        return Promise.resolve([])
      }
      return api(idsArr, { apiType: 'separate' }).then(
        res => {
          try {
            let data = res.res.data.results
            return Promise.resolve(data)
          } catch (error) {
            return Promise.reject(error)
          }
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
    updatePoiDetailLoadingStatus({ commit }, status) {
      commit('SET_POI_DETAIL_LOADING', status)
    }
  }
}

export default state
